// source: pbtypes/gen/flight_connect/video_stream_info.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_flight_connect_transport_type_pb = require('../../../pbtypes/gen/flight_connect/transport_type_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_transport_type_pb);
goog.exportSymbol('proto.flight_connect.VideoStreamInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_connect.VideoStreamInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_connect.VideoStreamInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_connect.VideoStreamInfo.displayName = 'proto.flight_connect.VideoStreamInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_connect.VideoStreamInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_connect.VideoStreamInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_connect.VideoStreamInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.VideoStreamInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
transport: jspb.Message.getFieldWithDefault(msg, 1, 0),
lastRecvUtime: jspb.Message.getFieldWithDefault(msg, 2, 0),
bitrate: jspb.Message.getFieldWithDefault(msg, 3, 0),
frameCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
channelId: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_connect.VideoStreamInfo}
 */
proto.flight_connect.VideoStreamInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_connect.VideoStreamInfo;
  return proto.flight_connect.VideoStreamInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_connect.VideoStreamInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_connect.VideoStreamInfo}
 */
proto.flight_connect.VideoStreamInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.flight_connect.TransportType.Enum} */ (reader.readEnum());
      msg.setTransport(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLastRecvUtime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setBitrate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setFrameCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setChannelId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_connect.VideoStreamInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_connect.VideoStreamInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_connect.VideoStreamInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.VideoStreamInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransport();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLastRecvUtime();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBitrate();
  if (f !== 0) {
    writer.writeSint64(
      3,
      f
    );
  }
  f = message.getFrameCount();
  if (f !== 0) {
    writer.writeSint32(
      4,
      f
    );
  }
  f = message.getChannelId();
  if (f !== 0) {
    writer.writeSint32(
      5,
      f
    );
  }
};


/**
 * optional TransportType.Enum transport = 1;
 * @return {!proto.flight_connect.TransportType.Enum}
 */
proto.flight_connect.VideoStreamInfo.prototype.getTransport = function() {
  return /** @type {!proto.flight_connect.TransportType.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.flight_connect.TransportType.Enum} value
 * @return {!proto.flight_connect.VideoStreamInfo} returns this
 */
proto.flight_connect.VideoStreamInfo.prototype.setTransport = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional uint64 last_recv_utime = 2;
 * @return {number}
 */
proto.flight_connect.VideoStreamInfo.prototype.getLastRecvUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.VideoStreamInfo} returns this
 */
proto.flight_connect.VideoStreamInfo.prototype.setLastRecvUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional sint64 bitrate = 3;
 * @return {number}
 */
proto.flight_connect.VideoStreamInfo.prototype.getBitrate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.VideoStreamInfo} returns this
 */
proto.flight_connect.VideoStreamInfo.prototype.setBitrate = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional sint32 frame_count = 4;
 * @return {number}
 */
proto.flight_connect.VideoStreamInfo.prototype.getFrameCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.VideoStreamInfo} returns this
 */
proto.flight_connect.VideoStreamInfo.prototype.setFrameCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional sint32 channel_id = 5;
 * @return {number}
 */
proto.flight_connect.VideoStreamInfo.prototype.getChannelId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.VideoStreamInfo} returns this
 */
proto.flight_connect.VideoStreamInfo.prototype.setChannelId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


goog.object.extend(exports, proto.flight_connect);
